import { AirportSummaryIFrame } from './AirportSummaryIFrame';
import useAirportSummaryUrl from '../../hooks/use-airport-summary-url';
import { LoadingIndicatorCircular } from '../../components/indicators/LoadingIndicatorCircular';

export default function AirportSummary() {
    const { url, error, loading } = useAirportSummaryUrl(null);

    return (
        <div className="h-100 d-flex flex-column position-relative">
            {error && <div className="text-error text-center">{error}</div>}
            {loading && <LoadingIndicatorCircular />}
            {!error && url && <AirportSummaryIFrame url={url} />}
        </div>
    );
}
